import { border, rgba } from "polished";

// DEFINE MAIN COLORS
const mainColors = {
  light: {
    primary: "#292929",
    secondary: "#1f3a4d",
    background: "#efebe9",
    text: "#292929",
  },
  dark: {
    primary: "#D9D9D9",
    secondary: "#4D9093",
    background: "#1F1F1F",
    text: "#D9D9D9",
  },
};

// Helper function for palette
const getPalette = (mode) => ({
  mode,
  primary:
    mode === "light"
      ? { main: "#292929", contrastText: "#fff" }
      : { main: "#D9D9D9", contrastText: "rgba(0,0,0,0.87)" },
  secondary:
    mode === "light"
      ? { main: "#1f3a4d", contrastText: "#fff" }
      : { main: "#4D9093", contrastText: "rgba(0,0,0,0.87)" },
  text:
    mode === "light"
      ? {
          primary: "rgba(0,0,0,0.87)",
          secondary: "rgba(0,0,0,0.7)",
          disabled: "rgba(0,0,0,0.48)",
        }
      : {
          primary: "#fff",
          secondary: "rgba(255,255,255,0.8)",
          disabled: "rgba(255,255,255,0.6)",
          icon: "rgba(255,255,255,0.22)",
        },
  background:
    mode === "light"
      ? { paper: "#efebe9", default: "#ccc" }
      : { paper: "#1F1F1F", default: "#ddd" },
});

// Helper function for typography
const getTypography = () => ({
  fontFamily: "Figtree, Inter, Lato, sans-serif",
  button: { textTransform: "none" },
  body1: {
    fontSize: "1rem", // Default 16px
  },
  body2: {
    fontSize: "0.875rem", // Default 14px
  },
  caption: {
    fontSize: "0.75rem", // Default 12px
  },
});

// Helper function for MuiPaper styles
const getMuiPaperStyles = () => ({
  styleOverrides: {
    root: {
      transition: "all 0.4s ease-in-out",
      opacity: "0.9",
      borderRadius: "4px",
      boxShadow: "0px 0px 8px rgba(100, 100, 100, 0.5)",
      border: "1px solid rgba(100, 100, 100, 0.5)",
      "&:hover": {
        boxShadow: "4px 4px 2px rgba(100, 100, 100, 0.3)",
        borderRadius: 0,
        opacity: "1",
      },
    },
  },
});

// Helper function for MuiButton styles
const getMuiButtonStyles = (mode) => ({
  styleOverrides: {
    root: {
      border: "1px solid " + rgba(mainColors[mode].secondary, 0.6),
      transition: "all 0.4s ease-in-out",
      borderRadius: "4px",
      "&:hover": { borderRadius: 0 },
    },
    outlined: {
      border: "1px solid " + rgba(mainColors[mode].secondary, 0.6),
      backgroundColor: rgba(mainColors[mode].secondary, 0.1),
      "&:hover": {
        boxShadow: "4px 4px 2px rgba(100, 100, 100, 0.25)",
        // borderRadius: 0,
      },
    },
    text: {
      border: "none",
      backgroundColor: "transparent",
      "&:hover": {
        boxShadow: "0px 4px 2px rgba(100, 100, 100, 0.2)",
        // borderRadius: 0,
      },
    },
    contained: {
      border: "1px solid " + rgba(mainColors[mode].secondary, 1),
      backgroundColor: rgba(mainColors[mode].secondary, 0.4),
      "&:hover": {
        boxShadow: "4px 4px 2px rgba(100, 100, 100, 1)",
        // borderRadius: 0,
      },
    },
  },
});

// Helper function for MuiAppBar styles
const getMuiAppBarStyles = () => ({
  styleOverrides: {
    root: {
      borderRadius: 0, // Override paper's border radius
      // Add any other AppBar specific styles here
      // For example, to prevent hover effects if any are inherited:
      "&:hover": {
        borderRadius: 0, // Ensure it stays squared on hover
        boxShadow: "none", // Optional: remove or define a specific shadow for AppBar on hover
      },
    },
  },
});

// Helper function for components
const getComponents = (mode) => ({
  // MuiPaper: getMuiPaperStyles(),
  MuiButton: getMuiButtonStyles(mode),
  MuiAppBar: getMuiAppBarStyles(),
});

export const style_getDesignTokens = (mode) => ({
  palette: getPalette(mode),
  typography: getTypography(),
  components: getComponents(mode),
});
